import { LanguageCodeEnum, type SupportedLanguage } from '@/constants/i18n'

/**
 * 规范化语言代码
 * 将各种语言代码变体统一为标准格式
 * @param lng - 原始语言代码
 * @returns 规范化后的语言代码
 */
export const normalizeLanguage = (lng: string): SupportedLanguage => {
  // 将 zh、zh-TW 等映射到 zh
  if (lng.startsWith('zh')) {
    return LanguageCodeEnum.Zh
  }
  // 将 en-US、en-GB 等映射到 en
  if (lng.startsWith('en')) {
    return LanguageCodeEnum.En
  }
  // 默认返回 zh
  return LanguageCodeEnum.Zh
}
